import React, { useState } from 'react';
import classlist from 'utils/classlist';

const Item: React.FC<any> = props => {
    const [show, setShow] = useState(false);

    const handleClick = () => {
        setShow(!show);
    };

    return (
        <div className="question-list">
            <div className={classlist('question-title', show ? 'show-answer' : 'unshow-answer')} onClick={handleClick}>
                Q: {props.data.title}
            </div>
            {show && (
                <div className="answer">
                    <i>A: </i>
                    <div className="answer-detail" dangerouslySetInnerHTML={{ __html: props.data.answer }}></div>
                </div>
            )}
        </div>
    );
};

export default Item;
